import { render, staticRenderFns } from "./projectsupport-style-1.vue?vue&type=template&id=76c801db&"
import script from "./projectsupport-style-1.vue?vue&type=script&lang=js&"
export * from "./projectsupport-style-1.vue?vue&type=script&lang=js&"
import style0 from "./projectsupport-style-1.vue?vue&type=style&index=0&id=76c801db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports